import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { REGISTER_URL } from '../../pricing';

const {FiBriefcase, FiShoppingBag, FiBookOpen} = FiIcons;

const TargetGroups = () => {
  const groups = [
    {
      icon: FiBriefcase,
      title: 'สำหรับผู้ประกอบการและนักธุรกิจ',
      description: 'การทำพิธีตามหลักโหราศาสตร์จีนเป็นส่วนหนึ่งของการสร้างความมั่นใจและพลังใจในการดำเนินธุรกิจ หลายท่านมองว่าเป็นการสร้างพลังใจเชิงบวกให้กับตนเอง',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: FiShoppingBag,
      title: 'สำหรับเจ้าของกิจการขนาดเล็ก',
      description: 'เข้าใจหลักการขอพร และวิธีการวางเป้าหมายในการขอพรที่ถูกต้องมากขึ้น ไม่ได้ขอแบบกว้างเกินไปจนไม่รู้จะสำเร้จได้อย่างไร',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: FiBookOpen,
      title: 'สำหรับผู้สนใจโหราศาสตร์จีนและพิธีกรรม',
      description: 'เป็นโอกาสในการต่อยอดความรู้ด้านโหราศาสตร์จีน และพิธีกรรมตามแบบโบราณ เป็นประสบการณ์เชิงลึกที่หาโอกาสได้ยาก',
      color: 'from-purple-500 to-purple-600'
    }
  ];

  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            ข้อมูลสำหรับผู้สนใจแต่ละกลุ่ม
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ทริปนี้เหมาะสำหรับผู้ที่มีความสนใจในด้านต่าง ๆ
          </p>
        </motion.div>

        <div className="space-y-12">
          {groups.map((group, index) => (
            <motion.div
              key={index}
              initial={{opacity: 0, x: index % 2 === 0 ? -50 : 50}}
              whileInView={{opacity: 1, x: 0}}
              transition={{duration: 0.8, delay: index * 0.1}}
              viewport={{once: true}}
              className={`flex flex-col lg:flex-row items-center gap-8 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Icon and Title */}
              <div className="lg:w-1/3">
                <div
                  className={`w-20 h-20 bg-gradient-to-br ${group.color} rounded-2xl flex items-center justify-center mb-4 mx-auto lg:mx-0`}
                >
                  <SafeIcon icon={group.icon} className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 text-center lg:text-left">
                  {group.title}
                </h3>
              </div>

              {/* Description */}
              <div className="lg:w-2/3">
                <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg">
                  <p className="text-gray-700 leading-relaxed text-lg">
                    {group.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8, delay: 0.4}}
          viewport={{once: true}}
          className="mt-8 text-center"
        >
          <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">เหมาะสำหรับทุกระดับความรู้</h3>
            <p className="text-lg opacity-90 max-w-3xl mx-auto">
              ไม่ว่าคุณจะมีความรู้พื้นฐานหรือเป็นผู้เชี่ยวชาญ
              ทริปนี้ได้รับการออกแบบให้เหมาะสมกับผู้เข้าร่วมทุกระดับ
            </p>
          </div>
        </motion.div>

        <div className="mt-8 text-center">
          <a
            href={REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-bold rounded-full hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            ลงทะเบียนเข้าร่วมทริปนี้
          </a>
        </div>
      </div>
    </section>
  );
};

export default TargetGroups;